import React, { useEffect, useRef, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { userState, cardListState } from "../../stores/atoms";
import { awsInstance } from "../../actions/api";
import {inputValidation} from "../../actions/utiles"
import Loading from './../Loading';

function ModalForCardRegister(props) {
  const [user] = useRecoilState(userState);
  const [cardNum1, setCardNum1] = useState("");
  const [cardNum2, setCardNum2] = useState("");
  const [cardNum3, setCardNum3] = useState("");
  const [cardNum4, setCardNum4] = useState("");
  const [validDate, setValidDate] = useState("");
  const [identifyNumber, setIdentifyNumber] = useState("");
  const [password, setPassword] = useState("");
  const [nickName, setNickName] = useState("");
  const [, setCardList] = useRecoilState(cardListState);
  const [cardNum1Valid, setCardNum1Valid] = useState(true);
  const [cardNum2Valid, setCardNum2Valid] = useState(true);
  const [cardNum3Valid, setCardNum3Valid] = useState(true);
  const [cardNum4Valid, setCardNum4Valid] = useState(true);
  const [validDateValid, setValidDateValid] = useState(true);
  const [identifyNumberValid, setIdentifyNumberValid] = useState(true);
  const [passwordValid, setPasswordValid] = useState(true);
  const [nickNameValid, setNickNameValid] = useState(true);
  const [loading, setLoading] = useState(false);

  const cardNum1Ref = useRef();
  const cardNum2Ref = useRef();
  const cardNum3Ref = useRef();
  const cardNum4Ref = useRef();
  const validDateRef = useRef();
  const identifyNumberRef = useRef();
  const passwordRef = useRef();
  const nickNameRef = useRef();

  const onResetData = () => {
    setCardNum1("");
    setCardNum2("");
    setCardNum3("");
    setCardNum4("");
    setValidDate("");
    setIdentifyNumber("");
    setPassword("");
    setNickName("");
    setCardNum1Valid(true);
    setCardNum2Valid(true);
    setCardNum3Valid(true);
    setCardNum4Valid(true);
    setValidDateValid(true);
    setIdentifyNumberValid(true);
    setPasswordValid(true);
    setNickNameValid(true);
  };

  useEffect(() => {
    if (!props.show) {
      // modal close
      onResetData();
    }
  }, [props.show]);

  const onCardNumberChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    if (name === "cardNum1") {
      setCardNum1(value.replace(/[^0-9]/g, ""));
      if (value.length === 4) {
        setCardNum1Valid(true);
        cardNum2Ref.current.focus();
      } else {
        setCardNum1Valid(false);
      }
    } else if (name === "cardNum2") {
      setCardNum2(value.replace(/[^0-9]/g, ""));
      if (value.length === 4) {
        setCardNum2Valid(true);
        cardNum3Ref.current.focus();
      } else {
        setCardNum2Valid(false);
      }
    } else if (name === "cardNum3") {
      setCardNum3(value.replace(/[^0-9]/g, ""));
      if (value.length === 4) {
        setCardNum3Valid(true);
        cardNum4Ref.current.focus();
      } else {
        setCardNum3Valid(false);
      }
    } else {
      setCardNum4(value.replace(/[^0-9]/g, ""));
      if (value.length === 4) {
        setCardNum4Valid(true);
        validDateRef.current.focus();
      } else {
        setCardNum4Valid(false);
      }
    }
  };
  const onValidDateChange = (event) => {
    const value = event.target.value;
    setValidDate(value.replace(/[^0-9]/g, ""));
    if (value.length === 4) {
      setValidDateValid(true);
      passwordRef.current.focus();
    } else {
      setValidDateValid(false);
    }
  };
  const onPasswordChange = (event) => {
    const value = event.target.value;
    setPassword(value.replace(/[^0-9]/g, ""));
    if (value.length === 2) {
      setPasswordValid(true);
      identifyNumberRef.current.focus();
    } else {
      setPasswordValid(false);
    }
  };
  const onIdentifyNumberChange = (event) => {
    const value = event.target.value;
    setIdentifyNumber(value.replace(/[^0-9]/g, ""));
    if (value.length > 5) {
      setIdentifyNumberValid(true);
      nickNameRef.current.focus();
    } else {
      setIdentifyNumberValid(false);
    }
  };
  const onNicknameChange = (event) => {
    const value = event.target.value;
    setNickName(value);
    if (value.length > 0) {
      setNickNameValid(true);
    } else {
      setNickNameValid(false);
    }
  };

  const onFormSubmit = async (event) => {
    event.preventDefault();
    
    if (cardNum1.length < 4) {
      setCardNum1Valid(false);
      cardNum1Ref.current.focus();
      return false;
    } else {
      setCardNum1Valid(true);
    }
    if (cardNum2.length < 4) {
      cardNum2Ref.current.focus();
      return false;
    }
    if (cardNum3.length < 4) {
      cardNum3Ref.current.focus();
      return false;
    }
    if (cardNum4.length < 4) {
      cardNum4Ref.current.focus();
      return false;
    }
    if (validDate.length < 4) {
      validDateRef.current.focus();
      return false;
    }
    if (password.length < 2) {
      passwordRef.current.focus();
      return false;
    }
    if (identifyNumber.length < 6) {
      identifyNumberRef.current.focus();
      return false;
    }
    if (nickName.length < 1) {
      nickNameRef.current.focus();
      return false;
    }

    try {
      setLoading(true);
      const { data } = await awsInstance.post("business/card", {
        id: user.company_id,
        nickname: nickName,
        number: `${cardNum1}${cardNum2}${cardNum3}${cardNum4}`,
        month: validDate.toString().substring(0, 2),
        year: validDate.toString().substring(2, 4),
        identify_number: identifyNumber,
        password: password,
      });
      if (data.code === "SUCCESS") {
        onResetData();
        const { data } = await awsInstance.get("/business/card-list", {
          params: {
            id: user.company_id,
          },
        });
        if (data.code === "SUCCESS") {
          setCardList(data.data);
        }
        props.onHide(true);
      } else {
        alert(data.message);
      }
    } catch (e) {
      alert("카드 정보를 다시 확인해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span className="txt-center">카드 등록</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="txt-gray m-0 font-small line-height-1 txt-center">
              세금계산서 발행의 경우 고객센터 070-7114-0418로 문의바랍니다.
              <br />
              연계고용제도를 활용하는 기업은 자동으로 ‘세금계산서용’ 가상카드가
              설정됩니다.
            </p>
            <Form
              id="register-form"
              className="register-form"
              onSubmit={onFormSubmit}
            >
              <div className="display-flex flex-column p-2">
                <p className="mt-4 mb-2 txt-dark-gray">카드번호</p>
                <div className="display-flex justify-content-between align-items-center">
                  <input
                    type="text"
                    className={`form-control width-25 ${inputValidation(
                      cardNum1Valid
                    )}`}
                    maxLength="4"
                    value={cardNum1}
                    name="cardNum1"
                    ref={cardNum1Ref}
                    onChange={onCardNumberChange}
                  />
                  &nbsp;-&nbsp;
                  <input
                    type="text"
                    className={`form-control width-25 ${inputValidation(
                      cardNum2Valid
                    )}`}
                    maxLength="4"
                    value={cardNum2}
                    name="cardNum2"
                    ref={cardNum2Ref}
                    onChange={onCardNumberChange}
                  />
                  &nbsp;-&nbsp;
                  <input
                    type="text"
                    className={`form-control width-25 ${inputValidation(
                      cardNum3Valid
                    )}`}
                    maxLength="4"
                    value={cardNum3}
                    name="cardNum3"
                    ref={cardNum3Ref}
                    onChange={onCardNumberChange}
                  />
                  &nbsp;-&nbsp;
                  <input
                    type="text"
                    className={`form-control width-25 ${inputValidation(
                      cardNum4Valid
                    )}`}
                    maxLength="4"
                    value={cardNum4}
                    name="cardNum4"
                    ref={cardNum4Ref}
                    onChange={onCardNumberChange}
                  />
                </div>
                <div className="display-flex mb-2 mt-2">
                  <div className="mr-1 w-100">
                    <p className="mb-1 txt-dark-gray">유효기간</p>
                    <input
                      type="text"
                      className={`form-control ${inputValidation(
                        validDateValid
                      )}`}
                      placeholder="MMYY"
                      maxLength="4"
                      value={validDate}
                      name="validDate"
                      ref={validDateRef}
                      onChange={onValidDateChange}
                    />
                  </div>
                  <div className="ml-3 w-100">
                    <p className="mb-1 txt-dark-gray">비밀번호</p>
                    <input
                      type="password"
                      className={`form-control ${inputValidation(
                        passwordValid
                      )}`}
                      placeholder="비밀번호 앞 2자리"
                      maxLength="2"
                      name="password"
                      value={password}
                      ref={passwordRef}
                      onChange={onPasswordChange}
                    />
                  </div>
                </div>
                <div className="mb-2 mt-2">
                  <p className="mb-1 txt-dark-gray">
                    생년월일 또는 사업자등록번호
                  </p>
                  <input
                    type="text"
                    className={`form-control ${inputValidation(
                      identifyNumberValid
                    )}`}
                    value={identifyNumber}
                    maxLength="10"
                    name="identifyNumber"
                    ref={identifyNumberRef}
                    onChange={onIdentifyNumberChange}
                  />
                </div>
                <div className="mb-2 mt-2">
                  <p className="mb-1 txt-dark-gray">닉네임</p>
                  <input
                    type="text"
                    className={`form-control ${inputValidation(
                      nickNameValid
                    )}`}
                    value={nickName}
                    maxLength="10"
                    name="nickname"
                    ref={nickNameRef}
                    onChange={onNicknameChange}
                  />
                </div>
              </div>
              <p className="txt-center pt-2">
                <button type="submit" className="btn-blue-md">
                  등록
                </button>
              </p>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Loading loading={loading} />
    </>
  );
}

export default ModalForCardRegister;
